<template>

  <div class="table-responsive table-card mb-1">
    <table class="table table-nowrap align-middle" id="orderTable">
      <thead class="text-muted table-light">
      <tr class="text-uppercase">
        <th class="sort" data-sort="id">شماره سفارش</th>
        <th class="sort" data-sort="date">تاریخ سفارش</th>
        <th class="sort" data-sort="total">مبلغ سفارش</th>
        <th class="sort" data-sort="income">درآمد</th>
        <th class="sort" data-sort="status">وضعیت</th>
        <th class="sort" data-sort="action">عملیات</th>
      </tr>
      </thead>
      <tbody class="list">
      <tr v-for="(order, index) of orders" :key="index">
        <td class="id">
          <router-link v-if="false" :to="{name: 'order-details', params: {order_id: order.order_id}}" class="fw-medium link-primary"></router-link>
            #{{ order.order_id }}
        </td>
        <td class="date">
          {{ order.order_date }}
        </td>
        <td class="total" v-html="order.total"></td>
        <td class="income" v-html="order.income"></td>
        <td class="status">
                        <span :class="`badge badge-soft-${order.status_color} text-uppercase`">{{ order.status_label }}</span>
        </td>
        <td>
          <ul class="list-inline hstack gap-2 mb-0">
            <li
                class="list-inline-item"
                data-bs-toggle="tooltip"
                data-bs-trigger="hover"
                data-bs-placement="top"
                title="View"
            >
              <router-link v-if="false" to="/ecommerce/order-details" class="text-primary d-inline-block">
                <i class="ri-eye-fill fs-16"></i>
                مشاهده جزییات
              </router-link>
                <a :href="order.invoice_url" target="_blank" rel="noopener" class="text-primary d-inline-block">
                  <i class="ri-printer-line fs-16"></i>
                  چاپ فاکتور
                </a>
            </li>
          </ul>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="noresult" style="display: none">
      <div class="text-center">
        <lottie
            class="avatar-xl"
            colors="primary:#121331,secondary:#08a88a"
            :options="defaultOptions"
            :height="75"
            :width="75"
        />
        <h5 class="mt-2">Sorry! No Result Found</h5>
        <p class="text-muted">
          We've searched more than 150+ Orders We did not find any
          orders for you search.
        </p>
      </div>
    </div>
  </div>

</template>

<script>
import Lottie from "@/components/widgets/lottie";
import animationData from "@/components/widgets/msoeawqm.json";

export default {
  name: "order-list.vue",
  props: ['orders'],
  data() {
    return {
      defaultOptions: { animationData: animationData },
    }
  },
  components: {
    lottie: Lottie,
  }
}
</script>

<style scoped>

</style>
